module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAVxJREFUWEftmEuOwjAMhm1xhpFYWr0FS47BgtOx4BgsuUXlJRJnGBkFGlRVbWLHYSZI7Tq2v/x+JClC4x82zgcroDdDq4J/oeCGiH6Y+eYNNrYnoi0z3wHgN+U3l+JN13UnEdmJyJ6ZuQYkEREiXhDx2vf9MQWZAnzCAcAhQIkI14AcwdGw2XMKchEwpCDsEBGjIzfkDFz0uVsqoWSKEw7N6S71latBKHU8aYhYc+ZsZAFDIA+kxzbEVgGWQnrhTIBWyBpwZkAtZC24IsAc5NPpawibG2LuEFDX4NR4SaUBsApcsYIRdg5yvJEap0+xgjnIGnBuBZfqsebZ7VKw6RQ33SSpOffvY0YzhDVrtBdfUw1aAlvWeq78b9uSgCU2U1iVgp5AHlvVHPQGyJ3duYfY9175v+HR1Pazc+imph/useOb/vWhHfgfW6eagx+LrnC8AipESi5ZFfQq+ACbbyBHmV3sEAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close.png
// module id = /TeD
// module chunks = 1